var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"material-icons",class:_vm.outlined ? ['material-icons-outlined'] : [],staticStyle:{"user-select":"none"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }